export default {
  getMyCards: state => state.myCards,
  getReceivedCards: state => state.receivedCards,
  getCardDetail: state => state.cardDetail
};
